import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { txt } from 'libs/i18n';
import { useSession } from 'components/Authenticated';
import { mediaHasVideo } from 'api/model/project';
import { createCutMediaJob, startJob, } from 'api/model/services/services-api';
import { buildMediaFileUrl } from 'api/project-api';
import TimerangeSelectionForm, { formatTimeToISOString, getTimeInSeconds } from 'components/TimerangeSelectionForm';
import { Form, Modal, Divider, message, } from 'antd';
import TranscodeJobsInfo from 'components/TranscodeJobsInfo';
import { downloadUrl } from '../exports';
import styles from './style.module.less';
import { useEditorContext } from '../../contexts/projectSignal';
const CutMediaModal = ({ visible, onCancel, selectedTextTimestamps, }) => {
    const { session } = useSession();
    const { connection } = session;
    const { projectSignal } = useEditorContext();
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const projectDuration = getTimeInSeconds(projectSignal.peek().length);
    const mediaBegin = Form.useWatch('begin', form);
    const mediaEnd = Form.useWatch('end', form);
    const isUncutMedia = mediaBegin === '00:00:00.000' && mediaEnd === formatTimeToISOString(projectDuration);
    const hasDownloadClaim = session.login.hasClaim('file:download');
    const downloadUncutMedia = () => {
        if (!hasDownloadClaim) {
            return;
        }
        const url = buildMediaFileUrl(projectSignal.value);
        void message.success(txt('downloadStarted'));
        downloadUrl(url, `${projectSignal.value.description.name}.mp4`);
    };
    const startCuttingJob = async () => {
        if (!hasDownloadClaim) {
            return;
        }
        setIsLoading(true);
        const selectedBegin = form.getFieldValue('begin');
        const selectedEnd = form.getFieldValue('end');
        const jobId = await createCutMediaJob(connection, selectedBegin, selectedEnd, projectSignal.value.id, `${projectSignal.value.description.name}_${selectedBegin}_${selectedEnd}`);
        setIsLoading(false);
        void startJob(connection, jobId);
    };
    const buttonText = () => {
        const mediaType = mediaHasVideo(projectSignal.peek().mediaInfo) ? 'Video' : 'Audio';
        const action = isUncutMedia ? 'download' : 'cut';
        return txt(`${action}${mediaType}`);
    };
    return (_jsxs(Modal, { open: visible, onCancel: onCancel, destroyOnClose: true, footer: false, children: [_jsx("h3", { children: txt('dlMedia') }), _jsx("div", { children: _jsx(Form, { form: form, onFinish: isUncutMedia ? downloadUncutMedia : startCuttingJob, children: _jsx(TimerangeSelectionForm, { form: form, submitLabel: buttonText(), loading: isLoading, title: mediaHasVideo(projectSignal.peek().mediaInfo) ? txt('downloadVideo') : txt('downloadAudio'), preselectedRange: selectedTextTimestamps, infoTooltipText: txt('cutTimeInfo'), projectDuration: projectDuration }) }) }), _jsx(Divider, { className: styles.divider }), _jsx("h4", { className: styles.heading, children: mediaHasVideo(projectSignal.peek().mediaInfo) ? txt('cutVideos') : txt('cutAudios') }), _jsx(TranscodeJobsInfo, { workerType: "cut-length", project: projectSignal.peek(), visible: visible, isLoading: isLoading })] }));
};
export default CutMediaModal;
